
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"4","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(0 1 1 0 0 0)","fill":"#DCDCDD","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"7","cy":"2","r":"1.5"}}),_c('circle',{attrs:{"cx":"12","cy":"2","r":"1.5"}}),_c('circle',{attrs:{"cx":"2","cy":"2","r":"1.5"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/objectMenu/menu.svg